import axios from 'axios';
import appConfig from 'config';
import store from 'redux/store';
import { authAgent, getAccessTokenSilent, getProfilePicAccessTokenSilent } from 'auth/authUtils';
import { setAccessToken, setProfilePicAccessToken } from 'redux/actions';

export const toaAxios = axios.create({
	baseURL: appConfig.apiBaseUri,
	timeout: 120000,
	headers: { 'content-type': 'application/json' },
});

export const profilePicAxios = axios.create({
	baseURL: appConfig.profileImageApi,
	timeout: 120000,
	headers: { 'content-type': 'application/json' },
});

toaAxios.interceptors.request.use(
	async config => {
		const state = store.getState();
		const accessToken = state.auth.accessToken;
		const expiresOn = state.auth.accessTokenExpiresOn;

		if (accessToken === null || expiresOn < new Date()) {
			let accessTokenResult = await getAccessTokenSilent(authAgent);
			store.dispatch(setAccessToken(accessTokenResult.accessToken, accessTokenResult.expiresOn));
			config.headers.common['Authorization'] = `Bearer ${accessTokenResult.accessToken}`;
		} else {
			config.headers.common['Authorization'] = `Bearer ${accessToken}`;
		}

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

profilePicAxios.interceptors.request.use(
	async config => {
		const state = store.getState();
		const accessToken = state.auth.profilePicAccessToken;
		const expiresOn = state.auth.profilePicAccessTokenExpiresOn;

		if (accessToken === null || expiresOn < new Date()) {
			let accessTokenResult = await getProfilePicAccessTokenSilent(authAgent);
			store.dispatch(setProfilePicAccessToken(accessTokenResult.accessToken, accessTokenResult.expiresOn));
			config.headers.common['Authorization'] = `Bearer ${accessTokenResult.accessToken}`;
		} else {
			config.headers.common['Authorization'] = `Bearer ${accessToken}`;
			config.headers.common['content-type'] = 'image/jpeg';
		}

		return config;
	},
	function (error) {
		return Promise.reject(error);
	}
);

export default toaAxios;
